import { useMemo } from 'react';
import { parseISO, isWithinInterval } from 'date-fns';
import { useInsightsDate } from '@services/InsightsDateProvider';
import { usePlansForShopIds } from '@services/localAds';

/**
 * Check if any shops had ads with budget > 0 during the current insights date period.
 *
 * @param {string[]} shopIds - Array of shop IDs to check
 * @returns {boolean} - True if any shop had ads during the period
 */
export const useHasAdsInPeriod = (shopIds) => {
	const { startDate, endDate } = useInsightsDate();
	const plans = usePlansForShopIds(shopIds);

	return useMemo(() => {
		if (!plans || plans.length === 0) return false;

		return plans.some((plan) => {
			if (!shopIds.includes(plan.shop) || plan.budget <= 0) return false;

			// Check if plan is currently live (active) OR if plan started within the time frame
			if (plan.status === 'live') {
				return true;
			}

			// Check if plan date falls within the insights date interval
			const planDate = parseISO(plan.date);
			const isWithinPeriod = isWithinInterval(planDate, { start: new Date(startDate), end: new Date(endDate) });

			return isWithinPeriod;
		});
	}, [plans, startDate, endDate, shopIds]);
};
